var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#E06060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.5C20.82 23.5 21.5 22.82 21.5 22V12C21.5 11.18 20.82 10.5 20 10.5C19.18 10.5 18.5 11.18 18.5 12V22C18.5 22.82 19.18 23.5 20 23.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.84 27.24C21.74 27 21.6 26.78 21.42 26.58C21.22 26.4 21 26.26 20.76 26.16C20.28 25.96 19.72 25.96 19.24 26.16C19 26.26 18.78 26.4 18.58 26.58C18.4 26.78 18.26 27 18.16 27.24C18.06 27.48 18 27.74 18 28C18 28.26 18.06 28.52 18.16 28.76C18.26 29.02 18.4 29.22 18.58 29.42C18.78 29.6 19 29.74 19.24 29.84C19.48 29.94 19.74 30 20 30C20.26 30 20.52 29.94 20.76 29.84C21 29.74 21.22 29.6 21.42 29.42C21.6 29.22 21.74 29.02 21.84 28.76C21.94 28.52 22 28.26 22 28C22 27.74 21.94 27.48 21.84 27.24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCancelIcon);
export default __webpack_public_path__ + "static/media/AlertCancelIcon.fe46a81dc2e1863c24b30519ce5bb6dc.svg";
export { ForwardRef as ReactComponent };